module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_bd_07.bb00545e.jpg";